import { h } from 'vue';
// @TODO why isn't import from npm working??
//import noUiSlider from 'nouislider';
const noUiSlider = window.noUiSlider;

// from https://github.com/willpercey-gb/veeno v0.6

let events = ['start', 'slide', 'update', 'change', 'set', 'end']

export default {
  name: 'NoUiSlider',
  props: {
    inputClass: {
      type: String,
      default: 'custom-slider-input'
    },
    inputName: {
      type: String,
      default: 'custom-slider-value'
    },
    options: {
      type: Object,
      default: () => ({
        start: [20, 80],
        connect: true,
        range: {
          'min': 0,
          'max': 100
        },
        snap: false
      })
    },
    vertical: {
      type: Boolean,
      default: false
    },
    handles: {
      type: [Number, Array],
      default: null
    },
    connect: {
      type: [Boolean, Array], 
      default: false    // validate values are boolean
    },
    tooltips: {
      type: [Boolean, Array], 
      default: false    // validate values are boolean
    },
    step: {
      type: Number,
      default: 0
    },
    range: {
      type: Object,
      required: true,
      validator: (value) => (!Array.isArray(value) && typeof value === 'object')
    },
    pipsy: {
      type: [Boolean, Object],
      default: () => false,
      validator: (value) => (typeof value === 'boolean' || !Array.isArray(value) && typeof value === 'object')
    },
    rtl: {
      type: Boolean,
      default: false 
    },
    // test below (set) prop for both types i.e. Number, Array
    set: {
      type: [Number, Array],
      default: null,
      validator: (value) => (typeof value === 'number' || Array.isArray(value))
    },
    behaviour: {
      type: String,
      default: 'tap',
      validator: (value) => ['drag', 'tap', 'fixed', 'snap', 'none'].indexOf( value !== -1)
    },
    getset: {
      type: Function,
      default: () => () => ''
    },

    modelValue: [Array, Number]
  },
  created () {
    this.optionz = Object.assign({}, 
      this.options, this.$props, 
      // this.vertical ? this.options.orientation = 'vertical': '',
      this.vertical && (this.options.orientation = 'vertical'),
      this.handles !== null || this.modelValue !== null && (
        this.options.start = this.handles !== null ? this.handles : this.modelValue
      ),
      this.rtl && (this.options.direction = 'rtl'),
      this.pipsy && !Object.keys(this.pipsy).length ? 
        this.options.pips = {mode: 'range',density: 5} : this.options.pips = this.pipsy
    )
    //console.log('created - handles',this.handles, this.modelValue, this.optionz)
  },
  mounted () {
    let slider = this.$el;
    this.options.orientation === 'vertical' && (slider.style.height = '100%')
    //console.log(this.optionz)
    noUiSlider.create(slider, this.optionz)
    
    events.forEach(event => {
      slider.noUiSlider.on(event, (values, handle, unencoded, tap, positions) => {
        var emitAsArray = true;
        if (this.modelValue !== null) {
          if (! Array.isArray(this.modelValue)) {
            emitAsArray = false;
          }
        } else if (this.handles !== null) {
          if (! Array.isArray(this.handles)) {
            emitAsArray = false;
          }
        }
        
        this.latestHandleValue = emitAsArray ? values.map(parseFloat) : parseFloat(values[0]);
        //console.log('emit4', this.latestHandleValue, values, event);
        this.$emit(event, {values: this.latestHandleValue, handle, unencoded, tap, positions})
        if (event === 'update') {
          window.clearTimeout(this.debouncedEmit);
          this.debouncedEmit = window.setTimeout(() => {
            this.$emit('update:modelValue', [...this.latestHandleValue])
          }, 100);
        }
      })
    })
    this.getset(slider)
  },
  //emits: ['update:modelValue'],
  render () {
    let child = h('input', 
        {
          //attrs: {
            'type': 'hidden',
            //name:this.name,
          //},
          //class:this.inputClass 
        },
      )
    let span = h('span', spanOptions,this.$slots.default) 

    return h('div', 
    divOptions, 
    [
      child,
      span
    ])
  },
  data () {
    return {
      optionz: Object,
      //latestHandleValue: null
    }
  },
  watch: {
    modelValue: {
      //immediate: true,
      handler(newValue) {
        const vm = this;
        var same = vm.latestHandleValue.toString() == newValue.toString();
        //console.log('same val', same, vm.latestHandleValue, newValue);
        if (same) return;
        
        window.clearTimeout(vm._sliderDebounce);
        vm._sliderDebounce = window.setTimeout(() => vm.$el.noUiSlider.set(newValue), 2000);
        
      },
      deep: true
    },
    // set (newValue) {
      
    // }
  }
}

let divOptions = {
    style: {
      position: 'relative'
    },
    class: {
      'veeno': true
    },
    attrs: { name:'custom-slider' }
}

let spanOptions = {
  style: {
    position: 'absolute',
    top: '-2.5rem'
  },
  class: {
    'veeno-span': true
  }
}